import { BeltSyllabus } from './syllabus_grades/types';
import { whiteBelt } from './syllabus_grades/whiteBelt';
import { whiteBeltYellowTag } from './syllabus_grades/whiteBeltYellowTag';
import { yellowBelt } from './syllabus_grades/yellowBelt';
import { yellowBeltGreenTag } from './syllabus_grades/yellowBeltGreenTag';
import { greenBelt } from './syllabus_grades/greenBelt';
import { greenBeltBlueTag } from './syllabus_grades/greenBeltBlueTag';
import { blueBelt } from './syllabus_grades/blueBelt';
import { blueBeltRedTag } from './syllabus_grades/blueBeltRedTag';
import { redBelt } from './syllabus_grades/redBelt';
import { redBeltBlackTag } from './syllabus_grades/redBeltBlackTag';
import { blackBelt } from './syllabus_grades/blackBelt';
import { blackBelt2nd } from './syllabus_grades/blackBelt2nd';

// Re-export type for consumers
export type { BeltSyllabus };

export const gradingSyllabus: BeltSyllabus[] = [
    whiteBelt,
    whiteBeltYellowTag,
    yellowBelt,
    yellowBeltGreenTag,
    greenBelt,
    greenBeltBlueTag,
    blueBelt,
    blueBeltRedTag,
    redBelt,
    redBeltBlackTag,
    blackBelt,
    blackBelt2nd
];
